import React from 'react';
import { Container } from '../../components/Container/Container';
import { useMeta } from '../../model/meta';
import { t } from '../../locales/translate';
import { CampaignsList } from './campaigns_list';

export function VoucherCampaigns(): JSX.Element {
  useMeta({ title: t.page.voucherCampaigns.voucherCampaigns });

  return (
    <Container>
      <CampaignsList />
    </Container>
  );
}
